<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-studentevaluate__evaluate-statistics">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getPage()">
                <el-form-item>
                    <el-select v-model="dataForm.classId" placeholder="请选择班级" clearable>
                        <el-option v-for="classList in classList" :key="classList.id" :label="classList.className"
                                   :value="classList.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.studentName" placeholder="请输入学生姓名" clearable></el-input>
                </el-form-item>
<!--                <el-form-item>-->
<!--                        <el-date-picker-->
<!--                                v-model="rollCallDate"-->
<!--                                type="date"-->
<!--                                placeholder="选择日期">-->
<!--                        </el-date-picker>-->
<!--                </el-form-item>-->
                <el-form-item>
                    <el-date-picker
                            v-model="rollCallDate"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getPage()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item label="排序:" prop="order">
                    <el-select v-model="dataForm.order" placeholder="选择排序字段" clearable @change="changeOrderHandle()">
                        <el-option v-for="list in studentExamineItemList" :key="list.id" :label="list.examineItemName"
                                   :value="list.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportStatistics()">{{ $t('export') }}</el-button>
                </el-form-item>
                <el-form-item   style="float: right" >
                    <el-button  type="primary"
                                style="float: right"
                                @click="ScoreConfig()">
                        得分情况设置
                    </el-button>
                </el-form-item>
                <el-form-item   style="float: right" >
                    <el-button  type="primary"
                                @click="exportIsClass()">
                        导出班评关联次数
                    </el-button>
                </el-form-item>
            </el-form>
            <!--               -->
            <!--            v-loading="dataListLoading"-->
            <el-table v-loading="dataListLoading" border @selection-change="dataListSelectionChangeHandle"
                      :data="dataList"
                      style="width: 100%;"
                      @cell-dblclick="bccelldblclick">
                <el-table-column fixed prop="班级名称" label="班级名称" header-align="center" align="center"></el-table-column>
                <el-table-column fixed prop="学生姓名" label="学生姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="座号" label="座号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="总得分" label="总得分" header-align="center" align="center"></el-table-column>
                <el-table-column v-if="studentEvaluateRule.isClassEvaluate === 1" prop="班评关联" label="班评关联" header-align="center" align="center" ></el-table-column>
                <el-table-column :prop="item" v-for="(item,index) in typeList" :key="index" :label="item"
                                 header-align="center" align="center"></el-table-column>
            </el-table>
            <!--班评关联详情 -->
            <el-dialog width="1500px" :visible.sync="open" title="班评关联详情" append-to-body>
              <el-form>
                <el-form-item>
                    <el-button type="danger" @click="exportScoreList()">
                        导出记录
                    </el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="dataListLoading" :data="classDataList" border >
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="examineItemName" label="检查项名称" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="evaluateItemName" label="评价项名称" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="evaluateItemType" label="评价项类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.evaluateItemType === 0" size="small" type="danger"
                                effect="dark">
                            扣分项
                        </el-tag>
                        <el-tag v-else-if="scope.row.evaluateItemType === 1" size="small" type="success"
                                effect="dark">
                            加分项
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="分数" header-align="center" align="center"></el-table-column>
                <el-table-column prop="isRepeal" label="操作类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isRepeal === 1" size="small" type="danger"
                                effect="dark">
                            已撤销
                        </el-tag>
                        <el-tag v-else-if="scope.row.isRepeal === 0" size="small" type="success"
                                effect="dark">
                            未撤销
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="notes" label="备注信息" header-align="center" align="center"></el-table-column>
                <el-table-column prop="imgSrc" label="图片" header-align="center" align="center" width="400px">
                  <template slot-scope="scope">
                      <el-image v-for="src in scope.row.imgList" :key="src" @click.stop="handleClickItem" :preview-src-list="scope.row.imgList" style="width: 100px; height: 100px" :src="src" fit="cover"></el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="videoSrc" label="视频" header-align="center" align="center" >
                    <template slot-scope="scope" >
                        <div class="video">
                            <el-dialog v-if="dialogVisible"
                                    append-to-body
                                    top="20px"
                                    :visible.sync="dialogVisible"
                                       width="800px"
                                       hight="800px"
                                    @closed="closeVideo"
                            >
                                <video
                                        width="100%"
                                        autoplay="autoplay"
                                        :src="playvideo"
                                        :poster="playvideo"
                                        controls="controls"
                                        id="video"
                                        preload="auto"
                                ></video>
                            </el-dialog>
                            <!-- 页面table显示的video标签 -->
                            <!-- <span>{{ scope.row.videoSrc }}</span> -->
                            <i v-if="scope.row.videoSrc"
                                    class="el-icon-video-play playIcon"
                               style="margin: 0 10px; font-size: 50px; "
                                    @click="handleCheck(scope.row)"
                            ></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="studentList" label="关联学生" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag
                                v-for="student in scope.row.studentList"
                                :key="student.id">
                            {{student.studentName}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
            </el-table>
            </el-dialog>
            <score-statistics v-if="scoreVisible" ref="scoreStatistics" @refreshDataList="getPage"></score-statistics>
            <student-is-class v-if="scoreVisible" ref="studentIsClass" @refreshDataList="getPage"></student-is-class>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import qs from 'qs'
import Cookies from 'js-cookie'
import ScoreStatistics from '../classevaluate/score-statistics'
import StudentIsClass from './student-is-class'
export default {
  components: { ScoreStatistics, StudentIsClass },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/studentEvaluate/studentEvaluateScore/statistics',
        getDataListIsPage: false,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      open:false,
      classList: [],
      typeList: [],
      studentEvaluateRule: '',
      studentExamineItemList: [],
      rollCallDate: '',
      dataForm: {
        startTime: '',
        studentName: '',
        order: '',
        endTime: '',
        classId: ''
      },
      studentIsClassVisible: false,
      scoreVisible: false,
      classDataList:[],
      dialogVisible: false, // 视频播放弹窗
      studentId: undefined
    }
  },
  watch: {
    dataList (e) {
    }
  },
  mounted () {
    this.getItemNameList()
    this.getItemList()
    this.getClassList()
    this.getRuleBySchoolId()
    this.init()
  },
  methods: {
      // 查看
      handleCheck (row) {
      this.dialogVisible = true
      this.playvideo = row.videoSrc // 存储用户点击的视频播放链接
      this.playvideoName = row.videoSrc // 存储用户点击的视频播放链接
    },
    //导出
    exportScoreList () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        classId: this.dataForm.classId,
        studentId: this.studentId,
        startTime: this.dataForm.startTime,
        endTime: this.dataForm.endTime
      })
      window.open(`${window.SITE_CONFIG.apiURL}/studentEvaluate/studentEvaluateScore/exportScoreStatistics?${params}`)
    },
    bccelldblclick(row, column, cell, event){
      console.log(row)
      console.log(column)
      console.log(event)
      if(column.property === "班评关联"){
        this.open = true
        console.log('打开详情')
      }
      console.log(row)
      this.classDataList = row.班评关联详情
      console.log('11111',this.classDataList)
      this.studentId = row.studentId
    },
    getPage () {
      // console.log(this.dataForm.classId)
      // console.log(this.rollCallDate)
      // const date = new Date(this.rollCallDate || new Date())
      // this.dataForm.startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
      // this.dataForm.endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '23:59:59'
      // console.log(this.dataForm.startTime)
      if (this.rollCallDate === null || this.rollCallDate.length <= 1) {
        this.dataForm.startTime = ''
        this.dataForm.endTime = ''
        this.rollCallDate = []
        return this.getDataList()
      }
      const date = new Date(this.rollCallDate[0])
      this.dataForm.startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
      const date2 = new Date(this.rollCallDate[1])
      this.dataForm.endTime = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' ' + '23:59:59'
      this.getDataList()
      this.init()
    },
    getItemNameList () {
      this.$http.get('studentEvaluate/studentExamineItem/getNameList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.typeList = res.data
      }).catch(() => {
      })
    },
    getRuleBySchoolId () {
      this.$http.get('studentEvaluate/studentEvaluateRule/getRuleBySchoolId').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.studentEvaluateRule = res.data
      }).catch(() => {
      })
    },
    getItemList () {
      this.$http.get('studentEvaluate/studentExamineItem/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.studentExamineItemList = res.data
        console.log(res.data)
      }).catch(() => {
      })
    },
    changeOrderHandle () {
      this.getDataList()
    },
    exportList () {
      var params = qs.stringify({
        token: Cookies.get('token'),
        ...this.dataForm
      })
      //   console.log(this.dataForm.questionsBankId, 'this.dataForm.questionsBankId')
      window.location.href = `${window.SITE_CONFIG.apiURL}/classEvaluate/evaluateScore/export?${params}`
    },
    // 获取信息
    getClassList () {
      this.$http.get('/classmanage/classmanage/getList/').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
        if (this.classList.length > 0) {
          this.dataForm.classId = this.classList[0].id
          this.getPage()
        }
      }).catch(() => {
      })
    },
    ScoreConfig () {
      this.scoreVisible = true
      this.$nextTick(() => {
        this.$refs.scoreStatistics.init()
      })
    },
    exportIsClass () {
      this.scoreVisible = true
      this.$nextTick(() => {
          this.$refs.studentIsClass.Form.classId = this.dataForm.classId
        this.$refs.studentIsClass.init()
      })
    },
    exportStatistics () {
      const params = qs.stringify({
        token: Cookies.get('token'),
        startTime: this.dataForm.startTime,
        endTime: this.dataForm.endTime,
        order: this.dataForm.order,
        classId: this.dataForm.classId
      })

      window.location.href = `${window.SITE_CONFIG.apiURL}/studentEvaluate/studentEvaluateScore/exportsStatistics?${params}`
    }
  }
}

</script>
